/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Especifica el estado del Movimiento.
 */
export type EstadoMovimiento = 'OK' | 'NOK' | 'NUEVO';

export const EstadoMovimiento = {
    OK: 'OK' as EstadoMovimiento,
    NOK: 'NOK' as EstadoMovimiento,
    NUEVO: 'NUEVO' as EstadoMovimiento
};

